module.exports = __webpack_public_path__ + "img/DE01045.d35dc906.png";